<template>
  <div>
    <v-card @click="onClickCard" :disabled="loading">
      <v-img
        v-if="content.status == 'completed'"
        :src="content.thumbnailUrl || ''"
        sizes="180px"
        height="180px"
      >
      </v-img>
      <div
        v-else-if="content.status == 'failed'"
        style="height: 180px"
        class="d-flex justify-center align-center"
      >
        <v-chip small color="error"> 失敗 </v-chip>
      </div>
      <div
        v-else
        style="height: 180px"
        class="d-flex justify-center align-center"
      >
        <v-chip small color="secondary"> 処理中 </v-chip>
      </div>
      <v-card-text class="pa-0">
        <v-container>
          <v-row align="center">
            <v-col cols="12">
              <v-table density="compact">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>種類</td>
                      <td>
                        <v-chip
                          v-if="content.category == 'photo'"
                          small
                          color="success"
                          >写真</v-chip
                        >
                        <v-chip v-else dark small color="purple">
                          <!-- {{ `動画（${getMovieSizeText(content.fileSeconds)}）` }} -->
                          {{ `動画` }}
                        </v-chip>
                      </td>
                    </tr>
                    <tr>
                      <td>撮影日</td>
                      <td>{{ formatDate(content.date) }}</td>
                    </tr>
                    <tr>
                      <td>単価</td>
                      <td>{{ `¥${content.price}` }}</td>
                    </tr>
                    <tr>
                      <td>購入数</td>
                      <td>{{ content.purchasedCount }}</td>
                    </tr>
                    <tr>
                      <td>売上</td>
                      <td>{{ content.revenue }}</td>
                    </tr>
                    <tr>
                      <td>ファイル名</td>
                      <td style="word-break: break-all;">{{ content.filename }}</td>
                    </tr>
                    <tr>
                      <td>シリアルNO</td>
                      <td>{{ content.serialNumber }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { MultimediaResponse } from "chaild-api/lib";
import dayjs from "dayjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "MemoruContentCard",

  props: {
    content: {
      type: Object as () => MultimediaResponse,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    formatDate(value: string): string {
      if (!value) {
        return "";
      }
      return dayjs(value).format("YYYY/MM/DD");
    },
    getMovieSizeText(seconds: number): string {
      if (!seconds) {
        return "0:00";
      }
      return `${Math.floor(seconds / 60)}:${Math.floor(seconds % 60)}`;
    },
    onClickCard() {
      this.$emit("click");
    },
  },
});
</script>
